import React from "react";
import { Unlock, TimerOff, Users, Trophy, BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const MAP = {
    OPEN: { label: "Open", icon: Unlock, cls: "bg-accent text-accent-foreground border-accent/50" },
    CLOSED_TIME: { label: "Closed · Time", icon: TimerOff, cls: "bg-secondary text-secondary-foreground border-border" },
    CLOSED_MAX_BIDDERS: { label: "Closed · Full", icon: Users, cls: "bg-secondary text-secondary-foreground border-border" },
    WON: { label: "Won", icon: Trophy, cls: "bg-brass/15 text-brass-foreground border-brass/40" },
    PAID: { label: "Paid", icon: BadgeCheck, cls: "bg-success/10 text-success border-success/30" },
};

export const StatusBadge = ({ status, className }) => {
    const m = MAP[status] || MAP.OPEN;
    const Icon = m.icon;
    return (
        <span
            data-testid="status-badge"
            role="status"
            className={cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium", m.cls, className)}
        >
            <Icon className="h-3.5 w-3.5" aria-hidden />
            {m.label}
        </span>
    );
};
